import React, { useEffect, useMemo, useState } from "react";
import "./LoadingSteps.scss";

export default function LoadingSteps({ query }) {
  const steps = useMemo(() => ([
    { text: "Preparing request" },
    { text: "Contacting Ysentinel" },
    { text: "Receiving response" },
    { text: "Parsing data" },
    { text: "Building visuals" }
  ]), []);

  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // step ticker
    if (currentStep < steps.length - 1) {
      const t = setTimeout(() => setCurrentStep((s) => s + 1), 1600);
      return () => clearTimeout(t);
    }
  }, [currentStep, steps.length]);

  useEffect(() => {
    // simple progress animation
    let rafId = 0;
    const start = performance.now();
    const duration = 5200; // ~5.2s full sweep

    const tick = (now) => {
      const elapsed = Math.min(now - start, duration);
      const pct = Math.min(99, Math.round((elapsed / duration) * 100));
      setProgress(pct);
      if (elapsed < duration) {
        rafId = requestAnimationFrame(tick);
      }
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div className="loading-steps-container">
      <div className="loading-card">
        {query && (
          <div className="loading-query">
            <strong>Query:</strong> {query}
          </div>
        )}
        
        <div className="loading-row">
          <span className="dots">
            <i></i><i></i><i></i>
          </span>
          <span className="loading-text">{steps[currentStep]?.text}…</span>
        </div>

        <div className="progress">
          <div className="bar" style={{ width: `${progress}%` }} />
        </div>

        <div className="loading-sub">
          This may take a few seconds. Please wait…
        </div>
      </div>
    </div>
  );
}
